import axios, { type AxiosError } from 'axios';
import axiosRetry, { exponentialDelay, isRetryableError } from 'axios-retry';

export const axiosClient = axios.create();

axiosRetry(axiosClient, {
    retries: 3,
    shouldResetTimeout: true,
    retryDelay: (retryNumber?: number, error?: AxiosError) => exponentialDelay(retryNumber, error, 1000),
    retryCondition: isRetryableError,
});
